import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import {
  IPortalAddress,
  ISmartyStreetsQuery,
  ISmartyStreetsSuggestResponse,
} from '@patient-ui/shared/models';
import { EnvironmentService } from '@patient-ui/shared-ui/utils';

@Injectable({
  providedIn: 'root',
})
export class SmartyStreetsService {
  constructor(
    private readonly http: HttpClient,
    private envService: EnvironmentService
  ) {}

  searchAddress(
    payload: ISmartyStreetsQuery
  ): Observable<ISmartyStreetsSuggestResponse> {
    let addressQuery = `search=${payload.prefix}`;
    addressQuery += payload.city ? `&prefer_cities=${payload.city}` : '';
    addressQuery += payload.state ? `&prefer_states=${payload.state}` : '';
    return this.http.get<ISmartyStreetsSuggestResponse>(
      `${this.envService.smartyStreetsBaseUrl}/lookup?auth-id=${this.envService.smartyStreetsSiteKey}&${addressQuery}`
    );
  }

  addZipCode(payload: IPortalAddress[]): Observable<IPortalAddress[]> {
    return of(payload);
  }
}
